import { setupForDark } from '@theme';
import classNames from 'classnames';

export declare type DisplayMode = 'mobile' | 'desktop';

const ContextMenuItem = ({
  children,
  displayMode = 'desktop',
  disabled = false,
  borderClassName,
  className,
  onClick = (event) => {},
  'data-testid': dataTestId
}: {
  children: React.ReactNode;
  displayMode?: DisplayMode;
  disabled?: boolean;
  borderClassName?: string;
  className?: string;
  onClick?: (event) => void;
  'data-testid'?: string;
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'cursor-pointer',
        displayMode === 'desktop'
          ? classNames('p-sm first:border-t-0 border-t-[1px]', className ?? 'P3R')
          : 'p-md P3M',
        displayMode === 'desktop'
          ? setupForDark('text-primary', borderClassName ?? 'border-primary')
          : setupForDark('text-secondary'),
        setupForDark('hover:bg-modal-secondary'),
        disabled && 'cursor-not-allowed',
        disabled && setupForDark('text-tertiary')
      )}
      onClick={(e) => {
        !disabled && onClick(e);
      }}
    >
      {children}
    </div>
  );
};
export default ContextMenuItem;
